export const getGraphicsEls = (self) => {
  self._checkNoProcessingTask();
  const working_layer = self._getWorkingLayerThrowable();
  return working_layer.getGraphicsEls();
};
